module.exports = __webpack_public_path__ + "img/icon3.75f4ca30.png";